module.exports = __webpack_public_path__ + "img/10.a60b1167.png";